<script setup lang="ts">
interface IProps {
  to: string
  icon?: Component
  title?: string
}

const props = defineProps<IProps>()
</script>

<template>
  <SheetClose as-child>
    <NuxtLinkLocale
      :href="props.to"
      class="w-full rounded-lg bg-blue-600 p-3 font-sans font-semibold text-white hover:bg-blue-700"
    >
      <div v-if="props.icon && props.title" class="flex items-center gap-2">
        <div
          class="flex size-9 min-w-9 items-center justify-center rounded-lg bg-white [&>svg]:size-5"
        >
          <component :is="props.icon" class="text-blue-600" />
        </div>
        <p>{{ props.title }}</p>
      </div>
      <slot v-else />
    </NuxtLinkLocale>
  </SheetClose>
</template>
